// extracted by mini-css-extract-plugin
export default {"title":"agentInsurance_title__h5jcX","number":"agentInsurance_number__7skpP"};